import type { UIStringsOverride } from "../i18n-ui.ts";

/** Portuguese — Brazil (pt-BR) UI strings. */
export const ptBR: UIStringsOverride = {
  actions: {
    addToCursor: "Adicionar ao Cursor",
    addToVscode: "Adicionar ao VS Code",
    askAI: "Perguntar à IA sobre esta página",
    connectMcp: "Conectar ao MCP",
    copied: "Copiado!",
    copyClaudeCode: "Copiar comando do Claude Code",
    copyCode: "Copiar código",
    copyCodex: "Copiar comando do Codex",
    copyMarkdown: "Copiar como Markdown",
    copyServerUrl: "Copiar URL do servidor",
    edit: "Editar no GitHub",
    export: "Exportar",
    exportEpub: "Exportar para EPUB",
    exportPdf: "Exportar para PDF",
    generating: "Gerando…",
    openIn: "Abrir em {name}",
    openInChat: "Abrir no chat",
    scrollToTop: "Voltar ao topo",
  },
  ask: {
    ai: "IA",
    clear: "Limpar a conversa",
    close: "Fechar",
    copy: "Copiar a conversa",
    empty: "Faça uma pergunta sobre a documentação.",
    error: "Desculpe, algo deu errado.",
    label: "Faça uma pergunta",
    placeholder: "Faça uma pergunta…",
    send: "Enviar",
    tip: "Dica: você pode abrir e fechar o chat com",
    title: "Perguntar à IA",
    you: "Você",
  },
  banner: { dismiss: "Fechar o anúncio" },
  changelog: {
    description: "Atualizações do produto e notas de lançamento.",
    showReleases: "Mostrar versões {version}",
    title: "Registro de alterações",
  },
  content: {
    diagramError: "Não foi possível renderizar este diagrama.",
  },
  feedback: {
    no: "Não",
    question: "Esta página foi útil?",
    thanks: "Obrigado pelo seu feedback!",
    yes: "Sim",
  },
  languageSwitcher: { label: "Idioma", untranslated: "Não traduzido" },
  nav: {
    back: "Voltar",
    breadcrumb: "Trilha de navegação",
    closeNavigation: "Fechar a navegação",
    deprecated: "obsoleto",
    featured: "Em destaque",
    githubRepository: "Repositório do GitHub",
    navigation: "Navegação",
    primary: "Principal",
    sections: "Seções",
    toggleNavigation: "Mostrar ou ocultar a navegação",
    toggleTheme: "Alternar o tema de cores",
  },
  notFound: {
    description: "Não encontramos a página que você está procurando.",
    home: "Voltar para a página inicial",
    title: "Página não encontrada",
  },
  page: {
    lastUpdated: "Última atualização em",
    next: "Próximo",
    pagination: "Paginação",
    previous: "Anterior",
    skipToContent: "Pular para o conteúdo",
  },
  search: {
    all: "Todos",
    allLanguages: "Todos os idiomas",
    askAi: "Perguntar à IA",
    askAiHint: "Obtenha uma resposta instantânea da IA",
    button: "Pesquisar",
    devOnly: "A busca está disponível na build de produção.",
    error: "Algo deu errado. Tente novamente.",
    label: "Pesquisar na documentação",
    navigate: "navegar",
    noResults: "Nenhum resultado encontrado.",
    open: "abrir",
    placeholder: "Pesquisar na documentação…",
    popular: "Populares",
    preview: "pré-visualizar",
    results: "Resultados",
  },
  toc: { title: "Nesta página" },
};
